import {NgForOf} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {StarRatingComponent} from '@modules/star-rating/star-rating.component';

@NgModule({
    imports: [
        MatIconModule,
        NgForOf
    ],
    exports: [
        StarRatingComponent
    ],
    declarations: [
        StarRatingComponent
    ]
})
export class StarRatingModule {

}
